// extracted by mini-css-extract-plugin
export default {"dateSwitch":"DateSwitch_dateSwitch__l3TYZ","datePickerArea":"DateSwitch_datePickerArea__YkV7s","switchBtn":"DateSwitch_switchBtn__m8Tl9","label":"DateSwitch_label__r5dB7"};